import { render } from "./Order.vue?vue&type=template&id=cdaa3b22&scoped=true"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"

import "./Order.vue?vue&type=style&index=0&id=cdaa3b22&lang=scss&scoped=true"

import exportComponent from "/var/www/html/OrderUser/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdaa3b22"]])

export default __exports__